import { useQuery } from 'react-query'
import { FileUploadsService, type RecentActivityParams } from '../services/fileUploads'
import type { RecentActivityResponse } from '../types'

/**
 * Hook for fetching recent upload activity stats
 */
export const useRecentActivity = (params: RecentActivityParams = {}) => {
  const { time_window = '24h' } = params

  return useQuery<RecentActivityResponse, Error>(
    ['recent-activity', { time_window }],
    () => FileUploadsService.getRecentActivity(params),
    {
      staleTime: 60000, // Consider data fresh for 1 minute
      cacheTime: 300000, // Keep data in cache for 5 minutes
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 1000,
    }
  )
}